__turbopack_context__.v({
  "content": "NotificationCard-module__4pXBfa__content",
  "delete": "NotificationCard-module__4pXBfa__delete",
  "notification": "NotificationCard-module__4pXBfa__notification",
  "read": "NotificationCard-module__4pXBfa__read",
});
